import { render, staticRenderFns } from "./CourseAdvantages.vue?vue&type=template&id=93f74416&scoped=true&"
import script from "./CourseAdvantages.vue?vue&type=script&lang=js&"
export * from "./CourseAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./CourseAdvantages.vue?vue&type=style&index=0&id=93f74416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f74416",
  null
  
)

export default component.exports